import React from 'react';

const TestimonialSection = () => {
  const testimonials = [
    {
      id: 1,
      quote: "It is a privilege to lead an association committed to transforming Vidarbha into a hub of opportunity and growth. At AID, we believe that innovation, collaboration, and responsible entrepreneurship are the pillars of sustainable industrial progress",
      name: "Ashish Kale",
      position: "President",
      image: "img/testimonial/president.svg" 
    },
    {
      id: 2,
      quote: "Our mission is to empower businesses, attract meaningful investments, and build strong partnerships between industry, government, and society. Together, we are shaping a resilient and inclusive future one that positions Vidarbha as a dynamic force in India’s industrial landscape.",
      name: "Dr. Vijay Kumar Sharma",
      position: "Secretary",
      image: "img/testimonial/director.svg" 
    }
  ];

  return (
    <div className="testimonial_section" data-bg-img="img/testimonial/bg.jpg">
      <div className="overlay"></div>
      
      {/* Dual Testimonials Container */}
      <div className="fn_cs_dual_testimonials">
        <div className="container">
          <div className="testimonial-row">
            {/* Left Testimonial */}
            <div className="testimonial-col">
              <div className="testimonial-box">
                <div className="testimonial-item">
                  <img className="fn__svg" src="svg/quotes.svg" alt="svg" />
                  <div className="content_holder">
                    <p>{testimonials[0].quote}</p>
                    <div className="author-info">
                      <div className="author-image">
                        <img src={testimonials[0].image} alt={testimonials[0].name} />
                      </div>
                      <div className="author-details">
                        <h3>{testimonials[0].name}</h3>
                        <h5>{testimonials[0].position}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Right Testimonial */}
            <div className="testimonial-col">
              <div className="testimonial-box">
                <div className="testimonial-item">
                  <img className="fn__svg" src="svg/quotes.svg" alt="svg" />
                  <div className="content_holder">
                    <p>{testimonials[1].quote}</p>
                    <div className="author-info">
                      <div className="author-image">
                        <img src={testimonials[1].image} alt={testimonials[1].name} />
                      </div>
                      <div className="author-details">
                        <h3>{testimonials[1].name}</h3>
                        <h5>{testimonials[1].position}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;